import axios from "axios";

function clearAuthAndRedirect(reason) {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userId");
  } catch {}

  const path = window.location.pathname || "";
  if (path === "/login" || path === "/register") return;

  const next = encodeURIComponent(path + (window.location.search || ""));
  const params = new URLSearchParams();
  if (reason) params.set("reason", reason);
  if (next && next !== "%2F") params.set("next", next);
  const qs = params.toString();
  window.location.replace("/login" + (qs ? `?${qs}` : ""));
}

function handle401(err) {
  if (!err || !err.response) return Promise.reject(err);
  const status = err.response.status;
  if (status === 401) {
    const code = err.response.data?.code;
    const msg = err.response.data?.message || "";
    const expired =
      code === "token_expired" ||
      /süres/i.test(msg) ||
      /expired/i.test(msg);
    clearAuthAndRedirect(expired ? "expired" : code || "unauthorized");
  }
  return Promise.reject(err);
}

function attachAuth(instance) {
  if (!instance || instance.__authAttached) return instance;
  instance.interceptors.request.use((config) => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers = config.headers || {};
        if (!config.headers.Authorization && !config.headers.authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch {}
    return config;
  });
  instance.interceptors.response.use((response) => response, handle401);
  instance.__authAttached = true;
  return instance;
}

attachAuth(axios);

const originalCreate = axios.create.bind(axios);
axios.create = (config) => attachAuth(originalCreate(config));

export { attachAuth };
